import { defineComponent as _defineComponent } from 'vue';
import { computed, toRef } from "vue";
import { useConfigurationTemplateCreation } from "@/components/ConfigTemplates/useConfigurationTesting";
export default /*#__PURE__*/ _defineComponent({
    __name: 'CreateForm',
    props: {
        template: null,
        uuid: null
    },
    emits: ["created"],
    setup(__props, { emit }) {
        const props = __props;
        const createUrl = "/api/file_source_instances";
        const createTestUrl = "/api/file_source_instances/test";
        const title = computed(() => `Create a ${props.template.name} File Source`);
        const { ActionSummary, error, inputs, InstanceForm, onSubmit, submitTitle, loadingMessage, testRunning, testResults } = useConfigurationTemplateCreation("file source", toRef(props, "template"), toRef(props, "uuid"), createTestUrl, createUrl, (fileSource) => emit("created", fileSource));
        return { __sfc: true, createUrl, createTestUrl, props, title, emit, ActionSummary, error, inputs, InstanceForm, onSubmit, submitTitle, loadingMessage, testRunning, testResults };
    }
});
